// eslint-disable-next-line
import {injectable} from "inversify";
import {TYPE, rootContainer} from '../container/root';
import {IApiResponse, IHttpService} from "../http-service";
import {IPlanEditorModel} from "../../models/Plan";

@injectable()
class AdminManageMerchantsPlansService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async fetchPlanBillingFields(plan_id: number): Promise<IPlanEditorModel> {
        const res = await this.httpService.get<IApiResponse<IPlanEditorModel>>(`/rms-api/admin-merchants-plan-editor/${plan_id}`);
        return res.payload;
    }

    async updateUserPlanBillingFields(merchant_id: number, data: IPlanEditorModel): Promise<IPlanEditorModel> {
        const res = await this.httpService.post<IApiResponse<IPlanEditorModel>>(`/rms-api/admin-merchants-plan-editor/${merchant_id}`, { ...data });
        return res.payload;
    }

}

export default AdminManageMerchantsPlansService;